import { render } from "./InformationForm.vue?vue&type=template&id=29cc8cf6&scoped=true&ts=true"
import script from "./InformationForm.ts?vue&type=script&lang=ts"
export * from "./InformationForm.ts?vue&type=script&lang=ts"

import "./InformationForm.scss?vue&type=style&index=0&id=29cc8cf6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cc8cf6"]])

export default __exports__